import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {EnvironmentService} from '@services/enviroment/environment.service';
import {Product, ProductCategory} from '@interfaces/product';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  products: BehaviorSubject<Product[]> = new BehaviorSubject<Product[]>([]);
  productsObservable$ = this.products.asObservable();

  protected readonly http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  apiUrl = this.environmentService.getValue('apiUrl');

  fetchProducts(): Observable<Product[]> {
    return this.http.get(this.apiUrl + '/products')
      .pipe(
        map((res: any) => res.products),
      );
  }

  fetchCountryGraphData(country: string): Observable<any> {
    return this.http.get(this.apiUrl + '/country/' + country);
  }

  createNewProduct(product: FormData): Observable<any> {
    return this.http.post(this.apiUrl + '/products', product);
  }

  fetchCategories(): Observable<ProductCategory> {
    return this.http.get(this.apiUrl + '/categories')
      .pipe(
        map((res: any) => res.categories
        ),
      );
  }

  updateProductsList(products: Product[]): void {
    this.products.next(products);
  }

  fetchProductsPaginated(page: number = 1, per_page: number = 10): Observable<any> {
    return this.http.get(this.apiUrl + `/products?page=${page}&per_page=${per_page}`);
  }
}
